// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-search-field::v-deep .yxt-input.yxt-input--prefix .yxt-input__inner{padding-left:30px!important}", ""]);
// Exports
module.exports = exports;
